export default function (donationsService) {
  let vm;

  class LastCommitmentsController {
    constructor () {
      vm = this;
      vm.donationsService = donationsService;
      vm.orderBy = localStorage.getItem('orderBy') || '-timeISO';
    }

    setOrderBy (option) {
      vm.orderBy = option;
      localStorage.setItem('orderBy', option);
    }
  }

  return new LastCommitmentsController();
}



// WEBPACK FOOTER //
// ./client/app/components/last-commitments/last-commitments.controller.js